import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class GroupFilter extends BaseFilter {

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return GroupFilter;
    }
}
